<app-sound #sound></app-sound>
<app-page-modifications>
    <div [ngSwitch]="viewState">
        <app-warmup-intro *ngSwitchCase="'warmup-intro'"
            (clickEvent)="warmupIntroClickHandler()">
        </app-warmup-intro>
        <app-warmup-loading *ngSwitchCase="'warmup-preload'"
            [question]="question"
            [loadingTimeout]="config.loadingTime"
            (timeoutEvent)="loadingTimeoutHandler()"
            [total]="totalNumberOfQuestions"
            [shouldShowWarningModal]="false"
            [familiarisationCheck]="familiarisationCheck">
        </app-warmup-loading>
        <app-warmup-complete *ngSwitchCase="'warmup-complete'"
            (clickEvent)="warmupCompleteClickHandler()">
        </app-warmup-complete>
        <app-questions-intro *ngSwitchCase="'questions-intro'"
            (clickEvent)="questionsIntroClickHandler()">
        </app-questions-intro>
        <app-loading *ngSwitchCase="'preload'"
            [question]="question"
            [loadingTimeout]="config.loadingTime"
            (timeoutEvent)="loadingTimeoutHandler()"
            [total]="totalNumberOfQuestions"
            [familiarisationCheck]="familiarisationCheck">
        </app-loading>
        <app-practice-question
            *ngSwitchCase="'practice-question'"
            [factor1]="question.factor1"
            [factor2]="question.factor2"
            [sequenceNumber]="question.sequenceNumber"
            [questionTimeoutSecs]="config.questionTime"
            [soundComponent]="sound"
            (timeoutEvent)="questionTimeoutHandler($event)"
            (manualSubmitEvent)="manualSubmitHandler($event)"
            [familiarisationCheck]="familiarisationCheck">
        </app-practice-question>
        <app-spoken-practice-question
            *ngSwitchCase="'spoken-practice-question'"
            [factor1]="question.factor1"
            [factor2]="question.factor2"
            [sequenceNumber]="question.sequenceNumber"
            [questionTimeoutSecs]="config.questionTime"
            [soundComponent]="sound"
            (timeoutEvent)="questionTimeoutHandler($event)"
            (manualSubmitEvent)="manualSubmitHandler($event)"
            [familiarisationCheck]="familiarisationCheck">
        </app-spoken-practice-question>

        <app-question *ngSwitchCase="'question'"
            [factor1]="question.factor1"
            [factor2]="question.factor2"
            [sequenceNumber]="question.sequenceNumber"
            [questionTimeoutSecs]="config.questionTime"
            [soundComponent]="sound"
            (timeoutEvent)="questionTimeoutHandler($event)"
            (manualSubmitEvent)="manualSubmitHandler($event)"
            [familiarisationCheck]="familiarisationCheck">
        </app-question>
        <app-spoken-question *ngSwitchCase="'spoken-question'"
            [factor1]="question.factor1"
            [factor2]="question.factor2"
            [sequenceNumber]="question.sequenceNumber"
            [questionTimeoutSecs]="config.questionTime"
            [soundComponent]="sound"
            (timeoutEvent)="questionTimeoutHandler($event)"
            (manualSubmitEvent)="manualSubmitHandler($event)"
            [familiarisationCheck]="familiarisationCheck">
        </app-spoken-question>
        <app-submission-pending *ngSwitchCase="'submission-pending'">
        </app-submission-pending>
    </div>
</app-page-modifications>
